import { makeStyles } from "@material-ui/core";
import React from "react";

import { Pagination } from "./pagination";
import { ItemsPerPageInput } from "./itemsPerPageInput";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
}));

interface Props {
    page: number;
    pageCount: number;
    setPage: (page: number) => void;
    itemsPerPage: number;
    setItemsPerPage: (val: number) => void;
    disabled: boolean;
}

export function PaginationControls({
    page,
    pageCount,
    setPage,
    itemsPerPage,
    setItemsPerPage,
    children,
    disabled,
}: React.PropsWithChildren<Props>) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Pagination
                page={page}
                setPage={setPage}
                pageCount={pageCount}
            />
            {children}
            <ItemsPerPageInput
                value={itemsPerPage}
                onChange={setItemsPerPage}
                disabled={disabled}
            />
        </div>
    );
}
